import { useSsrAdapter as a } from "./highrise721.mjs";
import { computed as l, inject as m, onBeforeMount as d, watchEffect as p } from "vue";
import { configProviderInjectionKey as v } from "./highrise1066.mjs";
import { cssrAnchorMetaName as R } from "./highrise1445.mjs";
import { exists as S } from "./highrise1050.mjs";
function g(o, i, f) {
  if (!i) return;
  const n = a(), s = l(() => {
    const {
      value: t
    } = i;
    if (!t)
      return;
    const e = t[o];
    if (e)
      return e;
  }), r = m(v, null), u = () => {
    p(() => {
      const {
        value: t
      } = f, e = `${t}${o}Rtl`;
      if (S(e, n)) return;
      const {
        value: c
      } = s;
      c && c.style.mount({
        id: e,
        head: !0,
        anchorMetaName: R,
        props: {
          bPrefix: t ? `.${t}-` : void 0
        },
        ssr: n,
        parent: r == null ? void 0 : r.styleMountTarget
      });
    });
  };
  return n ? u() : d(u), s;
}
export {
  g as useRtl
};
